<ngx-spinner template="<img class='loader-logo logo-animation' src='../assets/resources/logos/Logo-B-M3-V2.png'/>">
</ngx-spinner>
<router-outlet></router-outlet>